module.exports = __webpack_public_path__ + "static/media/product_640-5.bf8840bd.jpg";